import { Modal } from './modal';

export class SessionMonitor {
    constructor(o) {
        o = typeof o !== 'undefined' ? o : {};
        this.endpoints = typeof o.endpoints !== 'undefined' ? o.endpoints : '';
        this.translations = typeof o.translations !== 'undefined' ? o.translations : '';
    }

    initialize(o) {
        o = typeof o !== 'undefined' ? o : {};
        this.endpoints = typeof o.endpoints !== 'undefined' ? o.endpoints : this.endpoints;
        this.translations = typeof o.translations !== 'undefined' ? o.translations : this.translations;

        this.modalAboutToExpire = new Modal('', '', '');
        this.modalError = new Modal('', '', '');
        this.modalExpired = new Modal('', '', '');
        this.modalImpersonated = new Modal('', '', '');
        this.modalSignout = new Modal('', '', '');

        this.setModalProperties();
    }

    start() {
        this.addIframeThatChecksSession();
        this.addEventListenerToWindow();
    }

    setModalProperties() {
        let ok, footer, onclick;

        // AboutToExpire
        this.modalAboutToExpire.title = this.translations.internal.SessionExpirationWarningHeading;
        this.modalAboutToExpire.message = this.translations.internal.SessionExpirationWarningText;
        ok = this.translations.internal.SessionExpirationWarningButton;
        onclick = 'window.unify.renewSessionCookie();return false;';
        footer = `<button type="button" class="btn btn-default" onclick="${onclick}">${ok}</button>`;
        this.modalAboutToExpire.footer = footer;

        // Error
        ok = this.translations.internal.SessionErrorModalButton;
        onclick = `
            window.location.href='${this.endpoints.SignInUri}?redirectUri=${encodeURIComponent(window.location.href)}&prompt=false';
            this.disabled='true';
        `;
        footer = `<button type="button" class="btn btn-default" onclick="${onclick}">${ok}</button>`;
        this.modalError.footer = footer;
        this.modalError.message = this.translations.internal.SessionErrorModalText;
        this.modalError.options = { backdrop: 'static', keyboard: false };
        this.modalError.showHeaderCloseButton = false;
        this.modalError.title = this.translations.internal.SessionErrorModalHeading;

        // Expired
        this.modalExpired.title = this.translations.internal.SessionExpiredModalHeading;
        this.modalExpired.message = this.translations.internal.SessionExpiredModalText;
        this.modalExpired.footer = '';
        this.modalExpired.options = { backdrop: 'static', keyboard: false };
        this.modalExpired.showHeaderCloseButton = false;

        // Impersonated
        ok = this.translations.internal.ImpersonationActivatedModalButton;
        onclick = `
            window.location.href='${this.endpoints.SignInUri}?redirectUri=${encodeURIComponent(window.location.href)}&prompt=false';
            this.disabled='true';
        `;
        footer = `<button type="button" class="btn btn-default" onclick="${onclick}">${ok}</button>`;
        this.modalImpersonated.footer = footer;
        this.modalImpersonated.message = this.translations.internal.ImpersonationActivatedModalText;
        this.modalImpersonated.options = { backdrop: 'static', keyboard: false };
        this.modalImpersonated.showHeaderCloseButton = false;
        this.modalImpersonated.title = this.translations.internal.ImpersonationActivatedModalHeading;

        // Signout
        this.modalSignout.title = this.translations.internal.SessionSignedOutModalHeading;
        this.modalSignout.message = this.translations.internal.SessionSignedOutModalText;
        this.modalSignout.footer = '';
        this.modalSignout.options = { backdrop: 'static', keyboard: false };
        this.modalSignout.showHeaderCloseButton = false;
    }

    addEventListenerToWindow() {
        var that = this;
        window.addEventListener("message", function (e) {

            // We only handle "internal" messages.
            if (e.origin === window.location.protocol + "//" + window.location.host) {

                if (e.data === "signout") {
                    window.unify.signout("Manual", true);
                    // Note: No more events will be posted after signout, this is a "terminal" state.
                    that.modalSignout.show();
                }

                if (e.data === "expired") {
                    window.unify.signout("expired", true);
                    // Note: No more events will be posted after expired, this is a "terminal" state.
                    that.modalSignout.show();
                }

                if (e.data === "error") {
                    // Note: No more events will be posted after error, this is a "terminal" state.
                    console.log('monitorsessioncookie.js: "Signout error"', e);
                    that.modalError.show();
                }

                if (e.data === "elevated") {
                    // NOTE: This is not a "terminal" state.
                    // Pending page-refresh other events may happen. For example this event.. once every second. ;)
                }

                if (e.data === "impersonated") {
                    // NOTE: This is not a "terminal" state.
                    // Pending page-refresh other events may happen. For example this event.. once every second. ;)
                    that.modalImpersonated.show();
                }

                if (e.data === "about_to_expire") {
                    // NOTE: This is not a "terminal" state.
                    // Pending page-refresh other events may happen. For example this event.. once every second. ;)
                    that.modalAboutToExpire.show();
                }
                if (e.data === "unchanged") {
                    // User session is valid.
                    // Session status may have changed from about_to_expire to valid.
                    // If it has happend we hide possible open about_to_expire windows
                    that.modalAboutToExpire.hide();
                }

            }
        });
    }

    addIframeThatChecksSession() {
        var iframe = document.createElement('iframe');
        iframe.setAttribute('class', "hidden");
        iframe.setAttribute('id', "session_checker");
        iframe.setAttribute('src', "/unify/security/checksession");
        document.body.appendChild(iframe);
    }

    updateSessionCookie() {
        var that = this;
        $.ajax({
            type: "get",
            url: that.endpoints.SessionInfoUri + "?update_ttl=true",
            success: () => {
                that.modalAboutToExpire.hide();
            },
            error: () => {
                that.modalAboutToExpire.hide();
            }
        });
    }
}